import SubQuestion from './view';

export default SubQuestion;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/index.js